import { html, LitElement, nothing, unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import styles from '../css/Button.css?raw'
import { ApiBlockItemModel, BlockSettingsElementModelContentType, ExternalLinkElementModel, InternalLinkElementModel, LinkSettingsElementModel } from '../api/ContentDeliveryApi.schemas'
import { unsafeSVG } from 'lit/directives/unsafe-svg.js'

@customElement('lindberg-button')
export class Button extends LitElement {
	@property() href?: string
	@property() target?: string
	@property() type?: string = 'button'

	render() {
		const { href, target } = this
		const classes = ["button", ...this.getAttributeNames().filter(x => !["style", "color", "size"].includes(x) && !this.getAttribute(x)), ...["style", "color", "size"].map(x => this.getAttribute(x)).filter(Boolean)].map(x => x!.toLowerCase())
		if (href) {
			return html`<a href=${href ? href : ''} target=${target ? target : nothing} class="${classes.join(' ')}"><slot></slot></a>`
		} else if (this.type === 'inline') {
			return html`<span class="${classes.join(' ')}"><slot></slot></span>`
		} else 	{
			return html`<button type="button" class="${classes.join(' ')}"><slot></slot></button>`
		}
	}

	static styles = unsafeCSS(styles)
}

export function RenderButton(link: ApiBlockItemModel, inline: boolean = false) {
	const content = link.content as ExternalLinkElementModel | InternalLinkElementModel
	const settings = link.settings as LinkSettingsElementModel
	if (!settings.properties) settings.properties = {}
	if (!settings.properties.style) settings.properties.style = 'outline'
	const icon = content.properties?.icon?.at(0)?.properties?.image as string | undefined
	const iconPlacement = settings.properties.iconPlacement || 'Left'
	const target = (content.properties as any)?.link?.target || nothing
	const href = (content.properties as any)?.link?.route?.path || (content.properties as any)?.link?.url || (content.properties as any)?.link || nothing
	
	return html`<lindberg-button style="${settings.properties.style || nothing}" color=${settings.properties.color || nothing} size="${settings.properties.size || nothing}" href="${href}" target="${target}" type="${inline ? 'inline' : 'button'}">
		${icon && iconPlacement === 'Left' ? html`<lindberg-icon>${unsafeSVG(icon)}</lindberg-icon>` : nothing}
		${content.properties?.title}
		${icon && iconPlacement === 'Right' ? html`<lindberg-icon>${unsafeSVG(icon)}</lindberg-icon>` : nothing}
	</lindberg-button>`
}